import React from "react";
import PulseLoader from "react-spinners/PulseLoader";

function RoundButton(props) {
  return (
    <div
      className={`${props.className || ""} flex items-center justify-center w-full self-center h-14 py-4 px-12 rounded-full ${
        props.color === "red"
          ? "bg-snow-red"
          : props.color === "green"
            ? "bg-snow-green"
            : props.color === "white"
              ? "bg-snow-white"
              : props.color === "blue-gradient"
                ? "bg-gradient-to-br from-landing-page-gradient-blue-start to-landing-page-gradient-blue-end"
                : "bg-snow-blue-3"
      }
            ${
              props.disabled
                ? "opacity-60"
                : "hover:opacity-80 active:opacity-40"
            }
            ${props.fullWidth ? "w-full" : ""}`}
      onClick={(e) => {
        if (props.disabled !== true) {
          props.onClick(e);
        }
      }}
      data-testid={props["data-testid"] ?? props.label}
    >
      {props.loading ? (
        <PulseLoader
          color={props.loaderColor || "#fffafa"}
          size={props.loaderSize || 5}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <div
          className={`font-medium text-center ${
            props.font === "blue" ? "text-snow-primary" : "text-snow-white"
          } ${props.fontSize === "xl" ? "text-5xl" : "text-lg"}`}
        >
          {props.label}
        </div>
      )}
    </div>
  );
}

export default RoundButton;
